module.exports = __webpack_public_path__ + "img/invite-success.b47a842e.svg";